<script setup>
import { useCurrentUserProfile } from "~/composables/states"

const config = useRuntimeConfig()

const props = defineProps({
  article: {
    type: Object,
    default: null,
  },
})

const currentUserProfile = useCurrentUserProfile()

// return the tags as a comma separated string for openWeb comments data-article-tags
const getArticleTagsString = () => {
  const tags = props.article?.tags || []
  return tags.map((tag) => tag.name).join(", ")
}
const getArticleUrl = () => {
  const url = props.article?.url
  return url
}
useHead({
  script: [
    {
      src: `https://launcher.spot.im/spot/${config.public.OPENWEB_SPOT_ID}`,
      "data-spotim-module": "spotim-launcher",
      tagPosition: "bodyClose",
    },
  ],
})
</script>

<template>
  <div class="comments-section">
    <div
      :data-theme="currentUserProfile?.dark_mode ? 'dark' : 'light'"
      data-spotim-module="conversation"
      :data-post-url="getArticleUrl()"
      :data-article-tags="getArticleTagsString()"
      :data-post-id="String(article?.legacyId || article?.uuid)"
    ></div>
  </div>
</template>
